// extracted by mini-css-extract-plugin
export default {"borderBottom":"AdminMobileYearSaleStat_borderBottom__Wa0Pg","prevIcon":"AdminMobileYearSaleStat_prevIcon__CyNFj","nextIcon":"AdminMobileYearSaleStat_nextIcon__uve4P"};